import { getCurrentInstance } from 'vue'

export function breakpoint() {
  const vm = getCurrentInstance()
  const breakpoint = vm.proxy.$vuetify.breakpoint

  return {
    name: breakpoint.name,
    width: breakpoint.width,
  }
}
